module.exports = __webpack_public_path__ + "img/rf7.fd2d1c70.png";